<header class="app-header navbar">
  <ul class="nav navbar-nav d-md-down-none">
    <li class="nav-item d-flex">
      <div class="mr-2">
        <a class="nav-link" style="padding-top: 3px" href="#" (click)="goBack(); $event.preventDefault()">
          <span><i class="fa s-icon-back fa-2x text-white"></i></span>
        </a>
      </div>
      <div (click)="sessionClear()">
        <a class="nav-link" href="#" (click)="goMember(); $event.preventDefault()">
          <span><i class="fa fa-home fa-2x text-white icon-home-size"></i></span>
        </a>
      </div>
    </li>
    <li class="nav-item page-title">
      @if (pageTitleService.title$ | async; as pt) {
        <span class="title-area d-flex" [class.align-items-baseline]="!pt.isMaterial">
          @if (pt.isMaterial) {
            <span [class]="pt.materialClass">{{ pt.icon }}</span>
          } @else {
            <i [class]="pt.icon"></i>
          }
          <span>&nbsp;{{ pt.title }}</span>
        </span>
      }
    </li>
    <li class="nav-item">
      <a class="nav-link navbar-toggler sidebar-toggler" href="#" (click)="toggleSidebar(); $event.preventDefault()">
        <span><i class="fa fa-reorder fa-2x text-white"></i></span>
      </a>
    </li>
  </ul>
  <div class="col-md-12" style="position: fixed; top: 0;">
    <nav aria-label="パンくずリスト">
      <ol class="breadcrumb mb-1" style="background:rgba(255,255,255,0);border-bottom:none;">
        @if (breadcrumbService.breadcrumbs$ | async; as crumbs) {
          @for (crumb of crumbs; track crumb.label; let last = $last) {
            <li class="breadcrumb-item" [class.active]="last">
              @if (!last && crumb.link) {
                <a [routerLink]="crumb.link">{{ crumb.label }}</a>
              } @else {
                {{ crumb.label }}
              }
            </li>
          }
        }
      </ol>
    </nav>
  </div>
</header>

@if (activeTabsService.tabs$ | async; as tabs) {
  @if (tabs.length > 0) {
    <ul class="active-tab animated fadeIn">
      <li class="blindfold-parts"></li>
      @for (tab of tabs; track tab.routerLink) {
        <li>
          <a class="d-flex align-items-center"
             [title]="tab.name" [attr.aria-label]="tab.name"
             [routerLink]="tab.routerLink"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{ exact: tab.routerLink === '/pt-reservation' ? true : false }">
            @if (tab.iClass === 'material-icons-outlined' || tab.iClass === 'material-symbols-outlined') {
              <span [class]="tab.iClass + ' fa-fw fa-2x'">{{ tab.span }}</span>
            } @else {
              <i [class]="tab.iClass + ' fa-2x fa-fw'"></i>
            }
            <span class="tab-label">{{ tab.name }}</span>
          </a>
        </li>
      }
    </ul>
  }
}

<div class="app-body">
  <div style="display: flex; width: 100%;">
    <main class="main">
      <router-outlet></router-outlet>
    </main>
  </div>

  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li class="nav-item nav-close">
          <a class="navbar-toggler sidebar-toggler" href="#" (click)="closeSidebar(); $event.preventDefault()">
            <span class="navbar-toggler-icon"><i class="fa s-icon-menuClose fa-2x text-white"></i></span>
          </a>
        </li>
        @if (userPermission <= 10) {
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/owner" routerLinkActive="active" (click)="closeSidebar()">
              <i class="fa s-icon-master fa-2x mr-4 fa-fw" style="font-size: 2rem !important;"></i>
              <span>&nbsp;マスター管理</span>
            </a>
          </li>
        }
        @if (userPermission <= 30) {
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/studio" routerLinkActive="active" (click)="closeSidebar()">
              <i class="s-icon-studio fa-2x mr-4 fa-fw" style="font-size: 2rem !important;"></i>
              <span>&nbsp;店舗管理</span>
            </a>
          </li>
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/member" routerLinkActive="active" (click)="closeSidebar()">
              <i class="fa s-icon-members fa-2x mr-4 fa-fw" style="font-size: 2rem !important;"></i>
              <span>&nbsp;会員管理</span>
            </a>
          </li>
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/transaction" routerLinkActive="active" (click)="closeSidebar()">
              <i class="fa s-icon-settlement fa-2x mr-4 fa-fw" style="font-size: 2rem !important;"></i>
              <span>&nbsp;決済管理</span>
            </a>
          </li>
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/aggregation" routerLinkActive="active" (click)="closeSidebar()">
              <i class="fa s-icon-marketing fa-2x mr-4 fa-fw" style="font-size: 2rem !important;"></i>
              <span>&nbsp;データ集計</span>
            </a>
          </li>
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/marketing" routerLinkActive="active" (click)="closeSidebar()">
              <i class="fa fa-area-chart fa-2x mr-4 fa-fw" style="font-size: 2rem !important;"></i>
              <span>&nbsp;マーケティング</span>
            </a>
          </li>
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/machine-maintenance" routerLinkActive="active" (click)="closeSidebar()">
              <i class="fa fa-wrench fa-2x mr-4 fa-fw" style="font-size: 2rem !important;"></i>
              <span>&nbsp;マシンメンテナンス</span>
            </a>
          </li>
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/email" routerLinkActive="active" (click)="closeSidebar()">
              <i class="material-icons-outlined fa-fw fa-2x mr-4" style="font-size: 2rem !important;">email</i>
              <span>&nbsp;メール配信</span>
            </a>
          </li>
        }
        <li class="nav-item" (click)="sessionClear()">
          <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/pt-reservation" routerLinkActive="active" (click)="closeSidebar()">
            <i class="fa fa-calendar fa-2x mr-4 fa-fw" style="font-size: 2rem !important;"></i>
            <span>&nbsp;予約管理</span>
          </a>
        </li>
        @if (userPermission <= 10) {
          <li class="nav-item" (click)="sessionClear()">
            <a class="nav-link sidebar-toggler d-flex align-items-center" routerLink="/download" routerLinkActive="active" (click)="closeSidebar()">
              <i class="material-icons-outlined fa-fw fa-2x mr-4" style="font-size: 2rem !important;">download_2</i>
              <span>&nbsp;ダウンロード管理</span>
            </a>
          </li>
        }
        <li class="nav-item p-1" style="padding-right: 0 !important;">
          <a class="nav-link pt-3 pb-3 pl-5 bg-white text-blue d-flex align-items-center sidebar-logout" (click)="logout()" title="ログアウト" href="/login?logout=1">
            <i class="fa fa-sign-out mr-4 fa-fw text-blue" style="font-size: 2rem !important;"></i>
            <span>&nbsp;ログアウト</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>

<aside class="aside-menu d-none" aria-hidden="true">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#timeline" role="tab"><i class="icon-list"></i></a></li>
    <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#messages" role="tab"><i class="icon-speech"></i></a></li>
    <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#settings" role="tab"><i class="icon-settings"></i></a></li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane active" id="timeline" role="tabpanel">
      <div>Today</div><div>Meeting with Lucas</div><div>1 - 3pm</div><div>Palo Alto, CA</div>
      <div>Skype with Megan</div><div>4 - 5pm</div><div>On-line</div><div>Tomorrow</div>
      <div>New UI Project - deadline</div>
    </div>
    <div class="tab-pane p-3" id="messages" role="tabpanel">
      <div>Lukasz Holeczek</div><div>1:52 PM</div><div>Lorem ipsum dolor sit amet</div>
    </div>
    <div class="tab-pane p-3" id="settings" role="tabpanel">
      <h6>Settings</h6>
      <label>Option 1 <input type="checkbox" checked></label>
      <label>Option 2 <input type="checkbox"></label>
      <label>Option 3 <input type="checkbox"></label>
      <label>Option 4 <input type="checkbox" checked></label>
    </div>
  </div>
</aside>

<footer class="app-footer">
  <span class="ml-auto">Powered by &copy; <a href="//smartfit100.com">Smartfit 100</a></span>
</footer>
